/**
 * Nhãn cho màn hình P-Process.
 *
 * Bản tiếng Trung giữ NGUYÊN chữ trên tờ "P 流程" khách đưa. Dịch lại cho đẹp
 * thì người ở xưởng đối chiếu với tờ giấy dán trên tường sẽ không nhận ra bước
 * nào là bước nào.
 */
export const pProcessEn = {
  failed: "Failed inspection",
  concession: "Passed under concession",
  concessionHint:
    "This lot failed inspection and an administrator authorised it onward anyway. The chain continues, and the mark stays: somebody signed for this.",
  unlinked: "Manufacturing orders not linked to any proforma invoice: {{count}}",
  unlinkedPo: "Purchase orders not linked to any proforma invoice: {{count}}",
  unlinkedHint: "A manufacturing order only carries the proforma invoice number when it is raised from a confirmed sales order, and a purchase order only carries it when it is linked to the invoice. Documents without that link cannot be followed here — their stages will never light up, however complete the paperwork is.",
  title: "P-Process",
  intro:
    "Where each P-Process order has reached. All thirteen stages are read from the documents already in the ledger — nothing here is typed twice, and nothing is ticked by hand. A failed inspection stops the chain in red; a lot an administrator passed under concession carries that mark for good.",
  empty: "No order is running the P-Process yet.",
  error: "Unable to load the P-Process list.",
  piNo: "Proforma invoice",
  customer: "Customer",
  mo: "Manufacturing order",
  noMo: "No manufacturing order yet",
  lots: "Lot",
  stage: "Reached",
  progress: "Stages",
  current: "Waiting on",
  complete: "All stages done",
  outOfOrder: "Done out of order",
  outOfOrderHint:
    "These stages have a document even though an earlier stage does not. The shop floor did work out of sequence — that is what this row is telling you.",
  branch: "Route",
  purchased: "Material purchased",
  inStock: "Material in stock",
  subcontracted: "With subcontracting",
  inHouse: "In-house only",
  states: { done: "Done", pending: "Waiting", notApplicable: "Not applicable", failed: "Failed", concession: "Passed under concession", optional: "Not created" },
  manual: "Ticked by hand",
  manualHint:
    "The system has no form for this stage yet, so it is recorded as a tick with an attachment. Ask for a proper form once the sampling rule and pass criteria are agreed.",
  test: "Test report {{n}}",
  markDone: "Mark as done",
  markUndo: "Remove the tick",
  markNote: "Note",
  markFile: "Scan of the record",
  markSaved: "Stage recorded",
  photos: {
    button: "Photos",
    count: "{{count}} photos",
    inProgress: "In progress",
    general: "Other photos for this proforma invoice",
    generalHint: "For photos that do not belong to one stage.",
    orderEvidence: "Customer order evidence (saved on the proforma invoice)",
    orderEvidenceNone: "No order evidence on this proforma invoice yet.",
    orderEvidenceHidden: "Saved on the proforma invoice; you need access to Proforma Invoices to see it.",
    openPi: "Open the proforma invoice",
    hint: "Copy a photo in WeChat and press Ctrl+V here, drag it in, or choose a file. Saved automatically.",
    saving: "Saving…",
    saved: "Saved",
    error: "Unable to load or save the photos.",
    readOnly: "You can view these photos; adding or removing them needs the Update tick on P-Process.",
  },
  steps: {
    piIssued: "Customer order — proforma invoice issued",
    materialCheck: "Check whether the raw material is in stock",
    purchaseOrder: "Purchase order for the raw material",
    incomingTest: "Incoming material test report",
    productionOrder: "Production order",
    materialLedger: "Raw material in/out record",
    materialIssue: "Material requisition",
    ipqc: "In-process inspection report (IPQC)",
    buttonTest1: "Button test report — first round",
    subcontractOrder: "Subcontract processing order",
    subcontractMoves: "Subcontract in/out record",
    needleTest: "Needle-detector test report",
    buttonTest2: "Button test report — after subcontracting",
    packingRecord: "Product packing record",
    opticalPacking: "Optical sorter screening and packing record",
  },
  hints: {
    purchaseOrder:
      "At delivery the supplier must hand over a copy of the purchase order, a copy of the quality certificate, and the original delivery note showing the lot number.",
    incomingTest: "Factory checks appearance and thickness. Carries the lot number.",
    buttonTest1: "Appearance, dimension, colour, opening force, breaking force.",
    buttonTest2: "Same checks as the first round, repeated after the goods come back from the subcontractor.",
    packing: "Either packing route completes this stage; the row shows which one was used.",
  },
};

export const pProcessVi = {
  failed: "Kiểm KHÔNG ĐẠT",
  concession: "Cho qua có phê duyệt",
  concessionHint:
    "Lô này kiểm không đạt và quản trị vẫn cho đi tiếp. Chuỗi chạy tiếp, nhưng dấu vết ở lại: có người đã ký cho việc này.",
  unlinked: "Lệnh sản xuất chưa gắn PI nào: {{count}}",
  unlinkedPo: "Đơn mua chưa gắn PI nào: {{count}}",
  unlinkedHint: "Lệnh sản xuất chỉ mang số PI khi được mở từ đơn bán hàng đã xác nhận, và đơn mua chỉ mang số PI khi được gắn vào PI đó. Chứng từ thiếu mối nối này thì không theo dõi được ở đây — công đoạn của chúng sẽ không bao giờ sáng lên, dù giấy tờ có đủ tới đâu.",
  title: "Quy trình P",
  intro:
    "Từng đơn chạy quy trình P đang ở công đoạn nào. Cả mười ba nấc đều đọc thẳng từ chứng từ đã có trong sổ — không nhập lại lần hai, và không nấc nào tick tay. Kiểm không đạt thì chuỗi dừng đỏ; lô được quản trị cho qua có phê duyệt thì mang dấu đó vĩnh viễn.",
  empty: "Chưa có đơn nào chạy quy trình P.",
  error: "Không tải được danh sách quy trình P.",
  piNo: "Số PI",
  customer: "Khách hàng",
  mo: "Lệnh sản xuất",
  noMo: "Chưa mở lệnh sản xuất",
  lots: "Số LOT",
  stage: "Đang ở",
  progress: "Công đoạn",
  current: "Đang chờ",
  complete: "Đã xong toàn bộ",
  outOfOrder: "Làm nhảy cóc",
  outOfOrderHint:
    "Những bước này đã có chứng từ trong khi một bước trước đó thì chưa. Xưởng làm không theo thứ tự — đó chính là điều dòng này muốn báo.",
  branch: "Nhánh",
  purchased: "Phải mua nguyên liệu",
  inStock: "Có sẵn nguyên liệu",
  subcontracted: "Có gia công ngoài",
  inHouse: "Làm trong xưởng",
  states: { done: "Xong", pending: "Đang chờ", notApplicable: "Không áp dụng", failed: "Không đạt", concession: "Cho qua có phê duyệt", optional: "Không lập" },
  manual: "Đánh dấu tay",
  manualHint:
    "Hệ chưa có biểu mẫu cho bước này nên ghi bằng một dấu tick kèm tệp scan. Khi nào chốt được cỡ mẫu và tiêu chí đạt thì làm biểu mẫu đúng nghĩa.",
  test: "Báo cáo kiểm số {{n}}",
  markDone: "Đánh dấu đã làm",
  markUndo: "Bỏ đánh dấu",
  markNote: "Ghi chú",
  markFile: "Bản scan chứng từ",
  markSaved: "Đã ghi nhận công đoạn",
  photos: {
    button: "Ảnh",
    count: "{{count}} ảnh",
    inProgress: "Đang làm",
    general: "Ảnh khác của PI",
    generalHint: "Cho ảnh không thuộc riêng nấc nào.",
    orderEvidence: "Bằng chứng đặt hàng của khách (lưu trên PI)",
    orderEvidenceNone: "PI này chưa có bằng chứng đặt hàng.",
    orderEvidenceHidden: "Lưu trên PI; cần quyền xem PI mới thấy được.",
    openPi: "Mở PI",
    hint: "Sao chép ảnh trong WeChat rồi bấm Ctrl+V vào đây, kéo thả, hoặc chọn tệp. Tự lưu.",
    saving: "Đang lưu…",
    saved: "Đã lưu",
    error: "Không tải hoặc lưu được ảnh.",
    readOnly: "Bạn xem được ảnh; thêm hoặc gỡ ảnh cần ô Sửa của menu Quy trình P.",
  },
  steps: {
    piIssued: "Khách đặt hàng — đã có PI",
    materialCheck: "Kiểm còn nguyên liệu hay không",
    purchaseOrder: "Đơn mua nguyên liệu",
    incomingTest: "Báo cáo kiểm liệu đầu vào",
    productionOrder: "Lệnh sản xuất",
    materialLedger: "Sổ xuất nhập nguyên liệu",
    materialIssue: "Phiếu lĩnh liệu",
    ipqc: "Báo cáo kiểm trong sản xuất (IPQC)",
    buttonTest1: "Phiếu kiểm nút — lần 1",
    subcontractOrder: "Phiếu gia công ngoài",
    subcontractMoves: "Sổ xuất nhập gia công ngoài",
    needleTest: "Báo cáo máy dò kim",
    buttonTest2: "Phiếu kiểm nút — sau gia công ngoài",
    packingRecord: "Bảng ghi đóng gói sản phẩm",
    opticalPacking: "Bảng ghi sàng máy chọn quang và đóng gói",
  },
  hints: {
    purchaseOrder:
      "Khi giao hàng, nhà cung cấp phải kèm bản sao đơn mua, bản sao chứng nhận chất lượng và phiếu giao gốc có ghi số LOT.",
    incomingTest: "Xưởng tự kiểm ngoại quan và độ dày. Chứng từ mang số LOT.",
    buttonTest1: "Ngoại quan, kích thước, màu, lực đóng mở, lực phá hủy.",
    buttonTest2: "Kiểm lại đúng các mục như lần 1, sau khi hàng gia công ngoài về.",
    packing: "Đi đường nào cũng xong công đoạn này; dòng bên cạnh cho biết đơn đã đi đường nào.",
  },
};

export const pProcessZh = {
  failed: "检验不合格",
  concession: "特采放行",
  concessionHint:
    "此批检验不合格，但管理员仍审核放行。流程继续，但标记保留：有人为此签批。",
  unlinked: "未关联任何 PI 的生产单：{{count}} 张",
  unlinkedPo: "未关联任何 PI 的采购单：{{count}} 张",
  unlinkedHint: "生产单只有从已确认的销售订单开立时才会带上 PI 号，采购单也只有关联到该 PI 时才会带上。缺少这个关联的单据无法在此追踪——不论纸质单据多完整，其关卡都不会亮起。",
  title: "P 流程",
  intro:
    "每张 P 流程订单目前走到哪一关。全部十三关都直接读取系统内既有的单据，不需重复输入，也不再有人工勾选。检验不合格会让流程停在红色；经管理员特采放行的批次则永久保留该标记。",
  empty: "目前没有订单走 P 流程。",
  error: "无法加载 P 流程列表。",
  piNo: "PI 号",
  customer: "客户",
  mo: "生产单",
  noMo: "尚未开生产单",
  lots: "LOT 号",
  stage: "目前进度",
  progress: "关卡",
  current: "等待中",
  complete: "全部完成",
  outOfOrder: "跳关作业",
  outOfOrderHint: "这些关卡已有单据，但前面的关卡却还没有。现场没有依序作业——这正是本行要提醒的事。",
  branch: "路线",
  purchased: "需采购原材料",
  inStock: "有原材料",
  subcontracted: "有外发加工",
  inHouse: "厂内自制",
  states: { done: "完成", pending: "等待中", notApplicable: "不适用", failed: "不合格", concession: "特采放行", optional: "未建立" },
  manual: "人工勾选",
  manualHint: "系统尚无此关卡的表单，暂以勾选加附件记录。待抽样方式与允收标准确定后再制作正式表单。",
  test: "第 {{n}} 份测试报告",
  markDone: "标记为已完成",
  markUndo: "取消勾选",
  markNote: "备注",
  markFile: "单据扫描件",
  markSaved: "已记录此关卡",
  photos: {
    button: "图片",
    count: "{{count}} 张图片",
    inProgress: "开发中",
    general: "此 PI 的其他图片",
    generalHint: "用于不属于某一环节的图片。",
    orderEvidence: "客户下单凭证（保存在 PI 上）",
    orderEvidenceNone: "此 PI 还没有下单凭证。",
    orderEvidenceHidden: "保存在 PI 上；需要形式发票的查看权限才能看到。",
    openPi: "打开 PI",
    hint: "在微信中复制图片后在此按 Ctrl+V，或拖入、选择文件。自动保存。",
    saving: "正在保存…",
    saved: "已保存",
    error: "无法加载或保存图片。",
    readOnly: "您可以查看图片；添加或移除图片需要 P 流程菜单的修改权限。",
  },
  steps: {
    piIssued: "客人下 PO（需文件：PI）",
    materialCheck: "check 是否有原材料",
    purchaseOrder: "采购单",
    incomingTest: "来料测试报告",
    productionOrder: "生产单",
    materialLedger: "原材料出入记录",
    materialIssue: "领料单",
    ipqc: "IPQC 生产检验报告",
    buttonTest1: "钮扣产品测试报告单（第一次）",
    subcontractOrder: "外发加工单",
    subcontractMoves: "外发加工出入记录",
    needleTest: "钮扣产品过检针测试报告",
    buttonTest2: "钮扣产品测试报告单（外发后）",
    packingRecord: "产品包装记录表",
    opticalPacking: "光选机筛选与包装记录表",
  },
  hints: {
    purchaseOrder: "送货时须连同采购单副本、质量证书副本，以及已注明产品批号（LOT No.）的送货原件。",
    incomingTest: "本厂核查外观、厚度，含 LOT NUMBER。",
    buttonTest1: "外观／尺寸／颜色／开合力／破坏力。",
    buttonTest2: "外发加工回厂后，依第一次相同项目再检一次。",
    packing: "两条包装路线任一条完成即可；本行会显示实际走哪一条。",
  },
};
